<template>
  <div>
    <nav id="menu" class="main-menu">
      <ul>
        <li>
          <span><router-link to="/">Home</router-link></span>
        </li>

        <!-- <li v-show="token == null">
          <span><router-link to="/signup">Tourist Login</router-link></span>
        </li>
        <li v-show="token == null">
          <span><router-link to="/merchant-signup">Merchant Login</router-link></span>
        </li> -->
        <li>
          <span><router-link to="/about-us">About Us</router-link></span>
        </li>
        <li>
          <span><router-link to="/user-post">Requirements</router-link></span>
        </li>
        <li>
          <span><router-link to="/offer-post">Offers</router-link></span>
        </li>

        <li>
          <span><router-link to="/contact-us">Contacts</router-link></span>
        </li>
        <li v-show="token != null">
          <router-link to="/notification"><span class="fa-stack fa-2x" :data-count="count">
            <i class="fa fa-circle fa-stack-2x"></i>
            <i class="fa fa-bell fa-stack-1x fa-inverse"></i>
          </span></router-link>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
// import MenuLink from "./MenuLink";
import API from "../services/index";

export default {
  props: ["loggedIn"],
  data() {
    //alert(localStorage.getItem("role_id"));
    return {
      brand: process.env.VUE_APP_APPNAME,
      roleId: localStorage.getItem("role_id"),
      token: localStorage.getItem("token"),
      check:[],
      count:null
    };
  },
  components: {
    // MenuLink,
  },
  beforeMount() {
    this.notication()
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
  notication(){
    if(localStorage.getItem("token")!=null){
    const token = "Bearer " + localStorage.getItem("token");
    API.get("Sendrequirement/notification", {
          headers: { Authorization: token },
        })
        .then((res) => {
           
             res.data.data.forEach(element => {
               if(element.status == 1){
                       this.check.push(element.status)
               }
               this.count= this.check.length   
             });
     
        })
        .catch((err) => {
          console.log(err);
        });

    }
  

  }

  },
};
</script>

<style scoped>
.fa-stack[data-count]:after {
  position: absolute;
  right: 0%;
  top: 1%;
  content: attr(data-count);
  font-size: 30%;
  padding: 0.6em;
  border-radius: 999px;
  line-height: 0.75em;
  color: white;
  background: rgba(255, 0, 0, 0.85);
  text-align: center;
  min-width: 2em;
  font-weight: bold;
}

.fa-bell {
  color: rgb(252, 91, 98);
}

.sticky.fa-bell {
  color: rgb(252, 91, 98);
}
</style>